import { useEffect } from "react";
import axios from "axios";
import { LandingPage } from "./components/LandingPage";
import { WaroengForm } from "./components/WaroengForm";
import WaroengArchive from "./components/WaroengArchive";
const { DateTime } = require('luxon');

const SERVER = process.env.REACT_APP_SERVER;

// Pre-order window (Pacific time)
const PRE_ORDER_OPEN = DateTime.fromISO('2026-10-19T00:00', { zone: 'America/Los_Angeles' });
const PRE_ORDER_CLOSE = DateTime.fromISO('2026-10-23T23:59', { zone: 'America/Los_Angeles' });

export const WaroengPage = () => {
    // The server sleeps when idle; wake it now so submitting an order doesn't hang
    useEffect(() => {
        axios.get(`${SERVER}/health`).catch(() => {});
    }, []);

    const now = DateTime.now();
    const isOpen = now >= PRE_ORDER_OPEN && now <= PRE_ORDER_CLOSE;
    const isUpcoming = now < PRE_ORDER_OPEN;

    return (
        <>
            <LandingPage />

            <div className="relative w-full">
                {isOpen ? (
                    <WaroengForm />
                ) : (
                    <div className="mx-[10%] py-24 text-center">
                        <h2>
                            {isUpcoming
                                ? "Waroeng Vol.2 pre-orders open October 19."
                                : "Pre-orders are now closed."}
                        </h2>
                        <h4 className="text-grey-body mt-4">
                            {isUpcoming
                                ? "Pre-order October 19–23, pickup Saturday, October 24."
                                : "Thank you for your support! Follow us for the next Waroeng."}
                        </h4>
                    </div>
                )}
            </div>

            <WaroengArchive />
        </>
    );
};
